import React from 'react';
import { string, oneOfType, object, func, bool } from 'prop-types';
import { Loader, Icon } from '@tesla/design-system-react';
import { iconCloseSmall } from '@tesla/design-system-icons';
import styles from './styles.module.css.js';

var previewPropTypes = {
  /** Form name of component.  Will be passed to onRemove callback */
  name: string,
  /** Image object to display */
  image: oneOfType([string, object]),
  /** Callback triggered on remove button interaction */
  onRemove: func,
  /** Accessibility label for remove button */
  removeButtonLabel: string,
  /** Accessibility label for component */
  previewLabel: string,
  /** Sets loading state */
  loading: bool
};
var previewDefaultProps = {
  name: '',
  image: '',
  onRemove: function onRemove() {},
  removeButtonLabel: '',
  previewLabel: '',
  loading: false
};
var Preview = function Preview(_ref) {
  var name = _ref.name,
    image = _ref.image,
    onRemove = _ref.onRemove,
    removeButtonLabel = _ref.removeButtonLabel,
    previewLabel = _ref.previewLabel,
    loading = _ref.loading;
  var handleRemove = function handleRemove() {
    onRemove(name);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.Preview,
    style: {
      backgroundImage: "url(".concat(image.path, ")")
    },
    "aria-label": previewLabel,
    role: "img"
  }, /*#__PURE__*/React.createElement(Loader, {
    show: loading,
    className: styles.Loader
  }), !loading && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: styles.PreviewClose,
    onClick: handleRemove,
    "aria-label": removeButtonLabel,
    "data-test": "multi-photo-preview-remove-button"
  }, /*#__PURE__*/React.createElement(Icon, {
    data: iconCloseSmall
  })));
};

// Binding proptypes
Preview.propTypes = previewPropTypes;
Preview.defaultProps = previewDefaultProps;

export { Preview as default };
